export const CONTACT_CONFIG = 'CONTACT_CONFIG';
